import React, { Component } from 'react'

// ui
import Pagination from '../../components/uielements/pagination'

// redux
import { connect } from 'react-redux'
import objectActions from '../../redux/component_select_object/actions'

class Paginate extends Component {
    onShowSizeChange = (current, pageSize) => {
        this.props.changePageSize(pageSize)
    }

    onChange(pageNumber) {
        this.props.changeCurrentPage(pageNumber)
    }

    render() {
        const { total, pageSize, current } = this.props
        return (
            <div className="PaginateContainer">
                {total > 0 && <Pagination
                    showSizeChanger
                    onChange={pageNumber => this.onChange(pageNumber)}
                    onShowSizeChange={(current, pageSize) => this.onShowSizeChange(current, pageSize)}
                    current={current}
                    pageSizeOptions={['4', '6', '8', '12']}
                    total={total}
                    showQuickJumper
                    pageSize={pageSize}
                />}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        total: state.component_select_object.total,
        pageSize: state.component_select_object.pageSize,
        current: state.component_select_object.pageIndex,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        changePageSize: pageSize => {
            dispatch(objectActions.action.changePageSize(pageSize))
        },
        changeCurrentPage: pageNumber => {
            dispatch(objectActions.action.changeCurrentPage(pageNumber))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Paginate)
